import React from 'react'

const HandCoinIcon: React.FC<{ className?: string }> = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.875 5C11.875 3.27411 13.2741 1.875 15 1.875C16.7259 1.875 18.125 3.27411 18.125 5C18.125 6.72589 16.7259 8.125 15 8.125C13.2741 8.125 11.875 6.72589 11.875 5ZM15 3.125C13.9645 3.125 13.125 3.96447 13.125 5C13.125 6.03553 13.9645 6.875 15 6.875C16.0355 6.875 16.875 6.03553 16.875 5C16.875 3.96447 16.0355 3.125 15 3.125Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.625 6.875H6.98959C7.85333 6.875 8.69773 7.13067 9.4164 7.60978L12.2217 9.47997C13.2396 10.1586 13.6859 11.3733 13.4356 12.5H17.5V13.125H18.125C18.125 14.8732 16.8611 16.3651 15.1367 16.6525L11.3056 17.291C10.3935 17.443 9.45677 17.3022 8.62976 16.8887L5.625 15.3863V17.5H1.875V5H5.625V6.875ZM5.625 8.125V13.9887L9.18878 15.7706C9.7795 16.066 10.4486 16.1666 11.1001 16.058L14.9312 15.4195C15.8401 15.268 16.5522 14.6021 16.7898 13.75H12.3524L7.22046 11.184L7.77948 10.066L12.2033 12.2779C12.3695 11.6269 12.1191 10.9139 11.5283 10.52L8.72303 8.64984C8.20969 8.30762 7.60654 8.125 6.98959 8.125H5.625ZM3.125 16.25H4.375V6.25H3.125V16.25Z'
        fill='currentColor'
      />
      <path d='M17.5 12.5L18.125 12.5L18.125 13.125H17.5V12.5Z' fill='currentColor' />
    </svg>
  )
}

export default HandCoinIcon
